<template>

    <div class="button-image" :class="{ 'blue-bg': blue }">
        <simple-svg :src="src" :custom-class-name="customClass" />
    </div>

</template>

<script>

export default {
    name: 'ImageButton',

    computed: {
        customClass() {
            if (this.blue) return 'icon-blue icon';
            return this.redHover ? 'icon-red-hover icon' : this.red ? 'icon-red' : 'icon'
        }
    },

    props: {
        src: {
            type: String,
        },
        red: {
            type: Boolean,
            default: false
        },
        redHover: {
            type: Boolean,
            default: false
        },
        blue: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
.button-image {
    display: block;
    box-sizing: border-box;
    width: 25px + 4px * 2;
    height: 25px + 4px * 2;
    padding: 4px;
    border-radius: 8px;
    overflow: hidden;

    background-color: var(--color-btn-img-bg);

    .icon {

        path {
            stroke: var(--color-btn-img-primary) !important;
        }
    }

    .icon-blue {
        path {
            stroke: var(--color-blue) !important;
        }
    }

    &:hover {
        cursor: pointer;

        path {
            stroke: var(--color-text-dark) !important;
        }

        .icon-red-hover {
            path {
                stroke: var(--color-red) !important;
            }
        }
    }

    &:active {
        background-color: var(--color-bg);
        cursor: pointer;

        .icon {
            path {
                stroke: var(--color-blue-light) !important;
            }
        }

        .icon-red-hover {
            path {
                stroke: var(--color-red-light) !important;
            }
        }
    }

    &.blue-bg {
        background-color: var(--color-blue);

        .icon-blue {
            path {
                stroke: var(--color-btn-text) !important;
            }
        }

        &:hover {
            opacity: 0.9;
            background-color: var(--color-blue);
        }

        &:active {
            opacity: 0.8;
            background-color: var(--color-blue);
        }
    }

    svg-icon {
        width: 100%;
        height: 100%;
    }
}
</style>
